// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ButtonWrapper = styled.div({
	position: 'relative',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ChildrenWrapper = styled.div({
	paddingRight: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledChevron = styled.div({
	background: 0,
	border: 0,
	height: token('space.300', '24px'),
	lineHeight: 1,
	outline: 0,
	padding: 0,
	position: 'absolute',
	right: '0px',
	top: '50%',
	marginTop: token('space.negative.150', '-7px'),
	width: token('space.300', '24px'),
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledClose = styled.div({
	background: 0,
	border: 0,
	height: token('space.300', '24px'),
	lineHeight: 1,
	outline: 0,
	padding: 0,
	position: 'absolute',
	right: token('space.negative.050', '-4px'),
	top: '50%',
	marginTop: token('space.negative.150', '-12px'),
	width: token('space.300', '24px'),
});
